import styled from 'styled-components';
import Box from '@rsos/components/capstone/base/Box';

interface WrapperProps {
  sideBarOpen: boolean;
}

export const Wrapper = styled(Box).attrs<WrapperProps>(({ sideBarOpen }) => ({
  bg: 'foreground',
  width: sideBarOpen ? '180px' : '52px',
}))<WrapperProps>`
  height: 100%;
  transition: 0.3s;
`;

// Non-shrinking flex child so it stays pinned below the scrolling item list,
// rather than position:absolute (which overlapped a too-tall list).
export const FooterContainer = styled(Box).attrs({
  justify: 'center',
})`
  flex-shrink: 0;
  padding: 16px 22px;
  color: ${p => p.theme.colors.primaryBaseC2};
  width: 100%;
  cursor: pointer;
`;
